import {Model} from '../base.model';

export class InvoicePallet extends Model {
  description: string;
  weight: number;
  maxSquere: number;
}
